import { NftData } from '@graphql/nftfy/backend/shared/erc721/nftsByWallet'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import CardBase from '../../design-system/CardBase'

export interface CollectionCardProps {
  erc721: NftData
}
enum NftEnum {
  erc721 = 'ERC721'
}

export default function CollectionCard({ erc721 }: CollectionCardProps) {
  const isErc1155 = erc721.contract_type === NftEnum.erc721
  const route = useRouter()
  const actions = [
    {
      id: 'see-details',
      name: 'See Details',
      action: () => route.push(`/profile/${erc721.chainId}/nft/${erc721.address}/${erc721.tokenId}`),
      showAction: true
    }
  ]
  return (
    <CardBase
      totalNfts={erc721.nftsCount || 1}
      network={erc721.chainId}
      animationUrl={erc721.metadata?.animation_url}
      imageUrl={String(erc721.metadata?.image)}
      actions={actions}
      supported={isErc1155}
    >
      <Footer>
        <Info>
          <h4>{`${erc721.name || erc721?.metadata?.name}`}</h4>
        </Info>
      </Footer>
    </CardBase>
  )
}

const { Footer, Info } = {
  Footer: styled.div`
    background: ${props => props.theme.colors.gray[1]};
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
  `,
  Info: styled.div`
    padding: 8px 16px;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 28px 24px;

    > h4 {
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: normal;
      color: ${props => props.theme.colors.black};
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  `
}
